import { Paperclip } from 'lucide-react-native';
import { useState } from 'react';
import { twJoin } from 'tailwind-merge';

import { InquiryGuidelines } from '@/components/InquiryGuidelines';
import { Button, ButtonText } from '@/components/ui/button';
import { Divider } from '@/components/ui/divider';
import { HStack } from '@/components/ui/hstack';
import { Icon } from '@/components/ui/icon';
import { Text } from '@/components/ui/text';
import { VStack } from '@/components/ui/vstack';
import { ANALYTICS_EVENTS } from '@/constants/analytics';
import { segmentClient } from '@/util/analytics';

const HELP_TEXT = 'View Guidelines';

export const SurgeonAttachmentsInfoBox = () => {
  const [isGuidelinesOpen, setIsGuidelinesOpen] = useState(false);

  return (
    <>
      <HStack className={twJoin('items-center gap-2 rounded-lg bg-info-0 px-5 py-3')}>
        <Icon as={Paperclip} className="hidden h-5 w-5 text-primary-500 web:block" />
        <Divider
          orientation="vertical"
          className="mx-3 my-3 hidden w-px bg-outline-200 web:block"
        />
        <VStack className="flex-1 gap-1">
          <Text className="font-semibold text-xs text-typography-700">
            For surgical inquiries, attaching relevant files is strongly recommended.
          </Text>
          <Text className="font-normal text-xs text-typography-700">
            Remove all patient identifiable information (PHI) before uploading.
          </Text>
          <Button
            onPress={() => {
              segmentClient.track(ANALYTICS_EVENTS.INQUIRY_GUIDELINES_OPENED, {
                source: 'draft_inquiry_message',
              });

              setIsGuidelinesOpen(true);
            }}
            variant="link"
            size="xs"
            action="secondary"
            className="self-start">
            <ButtonText className="font-medium text-[12px] text-info-700 underline decoration-solid underline-offset-auto">
              {HELP_TEXT}
            </ButtonText>
          </Button>
        </VStack>
      </HStack>

      <InquiryGuidelines
        isOpen={isGuidelinesOpen}
        onClose={() => setIsGuidelinesOpen(false)}
        initialTab="attachment_guidelines"
      />
    </>
  );
};
